import Head from 'next/head'
import React from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';

function sustainability() {
  return (
    <>
   <Head>
   <title>Sustainability - Green Initiatives Efforts | Orientbell Tiles </title>
		<meta name="title" content="Sustainability - Green Initiatives Efforts | Orientbell Tiles"/>
		<meta name="description" content="At Orientbell Tiles, we sincerely desire to leave behind the Earth, for our children, at least as good as we inherited it – if not better. With this as a goal we have started our journey. And these are our baby steps."/>

   </Head>
    <div className='sustainability-wrap'>
        <div className='container'>
        <Breadcrumb>
				<Breadcrumb.Item href="https://www.orientbell.com">Home</Breadcrumb.Item>
				
				<Breadcrumb.Item href="https://www.orientbell.com/sustainability">Sustainability</Breadcrumb.Item>
			</Breadcrumb>
            <div className='sustainability-row'>
                <h1>Sustainability</h1>
                <div className='sus-paraWrap'>
                    {/* <h2>Summary</h2> */}
                    <p>Very silently, climate change has become the most deliberated topic across all global forums. In India too, increasingly, builders/ architects are addressing this issue upfront. Even the ordinary man on the street –in some manner is discussing about the worsening climate… maybe unknowingly.And there is a reason for that. </p>
					<p style={{ fontSize: '1.2em', fontStyle: 'italic', color: '#00953b' }}>While cities occupy 3% of the Earth’s land, they account for 60-80% of energy consumption and ~75% of carbon emissions. We needed to do something to reduce our burden on the environment. We need to make it better.</p>
					<p>At Orientbell Tiles, we sincerely desire to leave behind the Earth, for our children, at least as good as we inherited it – if not better. With this as a goal we have started our journey. And these are our baby steps.</p>
					<p>We have designed tiles specially for sun-facing surfaces. The tiles reflect heat, reducing the urban heat island effect, keep the inside temperature more comfortable and reducing the dependence on air-conditioning in these spaces.</p>
					<p>We have received the ISO: 50001:2018 certificate. This mandates a reduction in energy consumption year-on-year. This has encouraged us to think out-of-the-box. As a start, we implemented the following initiatives:</p>
                    <ul>
                        <li>We use, the cleanest of all the fuels, Natural Gas as our main fuel in all our factories.</li>
                        <li> We use non-conventional fuel like biomass in our spray drying units, thereby helping disposal of agricultural waste.</li>
                        <li>We also utilise waste heat from our kiln to our press dryers.</li>
                        <li>We are also using solar power.</li>
					</ul>
                    <p>Our Sikandrabad (UP) manufacturing facility discharges zero-waste into the environment. We reuse 100% of the process waste and water in our manufacturing system. Broken tiles are recycled. No waste is discharged outside our facility.</p> 
					<p>We have adopted three ponds measuring approximately 7 hectares in nearby villages and are geared up for rain water recharging. From 2022, we will be water positive. This means we will be recharging more water into the ground than what we will be consuming at our manufacturing facilities.</p>
					<p>We procure all our raw materials from domestic vendors, and 95% of our raw material is sourced from within 250 kms. It helps us reduce the fuel emission owing to logistics.</p>
					<p>Our factories feature amongst the greenest tile manufacturing units in India. We have about 5,500 trees on the 38-acre Hoskote Factory campus. We have about 5,000 Trees at our Sikandrabad (UP) factory. More importantly, our operating teams at these facilities even have an annual plantation goal as a part of their annual performance appraisal. It only strengthens our drive to be green– someday in the near future we may just become carbon neutral.</p>
					<p>In our small way, we are trying to rejuvenate our operations and by that rejuvenate the Earth. It’s a heartening start to a meaningful journey.</p>
                </div>
                {/* <div className='sus-paraWrap'>
                    <h2>INFORMATION WE COLLECT</h2>
                    <h3>Contact Information</h3>
                    <p>We may collect the user names and names of customers and visitors to our Web Site. We also may collect shipping and billing addresses, email addresses, phone numbers, digital contact information and purchase histories.</p>
                </div>
                <div className='sus-paraWrap'>
                    <h3>Demographic Information</h3>
                    <p>We may collect data about your age, gender, places you shop, reviews you give, and products and services you prefer.</p>
                </div>
                <div className='sus-paraWrap'>
                    <h3>Returns & Exchanges Information</h3>
                    <p>If you return an item to our stores or request an exchange or refund, we may ask you to provide your name, address, email address, phone number and your driver’s license or other government issued ID. We use the information you provide, including information from your government issued ID, to process and track returns and exchanges, help detect and prevent fraud, and administer our fraud and loss prevention program.</p>
                </div> */}
            </div>

            <div className='obl-sustainability-section'>
                <h2>Our Sustainability Booklet</h2>
                {/* <p>From our CSR initiatives to strengthen the education system of our country to the launch of new products with the latest technology in the market, we garner visibility everywhere. Here&rsquo;s what the world has to say about us.</p> */}
                <div className='obl-sustainability-row'>
                    <div class="obl-sustainability-col">
                        <a href="/Orientbell Sustainability booklet.pdf" download>
                            <div class="susta-image">
                                <img src="/book-cover.jpeg" alt="image" />
                            </div>
                            {/* <small>Date 04-03-2022</small> */}
                            <h4>Download Orientbell Sustainability Booklet</h4>
                        </a>
                    </div>
                   
                   
                </div>
            </div>


            <div className='obl-sustainability-section'>
                <h2> Certificates</h2>
                {/* <p>From our CSR initiatives to strengthen the education system of our country to the launch of new products with the latest technology in the market, we garner visibility everywhere. Here&rsquo;s what the world has to say about us.</p> */}
                <div className='obl-sustainability-row'>
                    
                    <div class="obl-sustainability-col">
                        <a href="/zero-waste.jpg" download>
                            <div class="susta-image">
                                <img src="/zero-waste.jpg" alt="image" />
                            </div>
                            {/* <small>Date 04-03-2022</small> */}
                            <h4>Zero Waste Discharge </h4>
                        </a>
                    </div>
                    <div class="obl-sustainability-col">
                        <a href="/save-water-cert.jpg" download>
                            <div class="susta-image">
                                <img src="/save-water-cert.jpg" alt="image" />
                            </div>
                            {/* <small>Date 04-03-2022</small> */}
                            <h4>Save Water </h4>
                        </a>
                    </div>
                    <div class="obl-sustainability-col">
                        <a href="/energy-cert.jpg" download>
                            <div class="susta-image">
                                <img src="/energy-cert.jpg" alt="image" />
                            </div>
                            {/* <small>Date 04-03-2022</small> */}
                            <h4>Save Energy</h4>
                        </a>
                    </div>
                    <div class="obl-sustainability-col">
                        <a href="/igbc.pdf" download>
                            <div class="susta-image">
                                <img src="/igbc.jpeg" alt="image" />
                            </div>
                            {/* <small>Date 04-03-2022</small> */}
                            <h4>Indian Green Building Council Membership</h4>
                        </a>
                    </div>
                    {/* <div class="obl-sustainability-col">
                        <a href="#">
                            <div class="susta-image">
                                <img src="https://server.orientbell.com/media/wysiwyg/no-image.jpg" alt="image" />
                            </div>
                            <small>Date 04-03-2022</small>
                            <h4>Orientbell Tiles launches ‘Estilo 2.0’ - stylish tiles like never before!</h4>
                        </a>
                    </div>
                    <div class="obl-sustainability-col">
                        <a href="#">
                            <div class="susta-image">
                                <img src="https://server.orientbell.com/media/wysiwyg/no-image.jpg" alt="image" />
                            </div>
                            <small>Date 04-03-2022</small>
                            <h4>Orientbell Tiles launches ‘Estilo 2.0’ - stylish tiles like never before!</h4>
                        </a>
                    </div>
                    <div class="obl-sustainability-col">
                        <a href="#">
                            <div class="susta-image">
                                <img src="https://server.orientbell.com/media/wysiwyg/no-image.jpg" alt="image" />
                            </div>
                            <small>Date 04-03-2022</small>
                            <h4>Orientbell Tiles launches ‘Estilo 2.0’ - stylish tiles like never before!</h4>
                        </a>
                    </div>
                    <div class="obl-sustainability-col">
                        <a href="#">
                            <div class="susta-image">
                                <img src="https://server.orientbell.com/media/wysiwyg/no-image.jpg" alt="image" />
                            </div>
                            <small>Date 04-03-2022</small>
                            <h4>Orientbell Tiles launches ‘Estilo 2.0’ - stylish tiles like never before!</h4>
                        </a>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default sustainability